import { CartLinesUpdateEvent } from '@shopify/events';

// Opens Horizon's cart drawer (<theme-drawer id="cart-drawer">) after a successful add.
// The cart-items-component already re-renders from the `sections` attached to the event promise.
function openCartDrawer() {
  const drawer = document.getElementById('cart-drawer');
  if (drawer && typeof drawer.open === 'function') drawer.open();
}

function initPdp(root) {
  if (root.dataset.pdpReady) return;
  root.dataset.pdpReady = 'true';
  const config = JSON.parse(root.querySelector('[data-pdp-config]').textContent);
  const $ = selector => root.querySelector(selector);
  const $$ = selector => [...root.querySelectorAll(selector)];
  const form = $('[data-hc-buy]');
  // Optional per-section text overrides (theme editor). Empty values keep the theme language text.
  const strings = Object.assign({}, config.strings);
  const overridesNode = root.querySelector('[data-pdp-strings]');
  if (overridesNode) {
    try {
      const overrides = JSON.parse(overridesNode.textContent) || {};
      Object.keys(overrides).forEach(key => {
        if (typeof overrides[key] === 'string' && overrides[key].trim() !== '') strings[key] = overrides[key];
      });
    } catch (e) { /* keep the theme language text */ }
  }
  const base = config.root.replace(/\/$/, '') + '/';
  const money = cents => new Intl.NumberFormat(config.locale, {style:'currency', currency:config.currency}).format(cents / 100);
  const unit = cents => new Intl.NumberFormat(config.locale, {style:'currency', currency:config.currency, minimumFractionDigits:2, maximumFractionDigits:2}).format(cents / 100);
  let current = config.variants.find(v => String(v.id) === $('[data-variant-id]').value) || config.variants[0];
  let selectedQuantity = current.option2;
  const quantitySelect = $('[data-buy-quantity]');
  [...quantitySelect.options].forEach(option => {
    const amount = option.value || '2500';
    option.textContent = `${Number(amount).toLocaleString(config.locale)}${option.value ? '' : '+'} ${strings.units}`;
  });
  let busy = false;
  function update(push = true) {
    const shape = $('[data-buy-shape]:checked')?.value;
    const quantity = selectedQuantity;
    const found = config.variants.find(v => v.option1 === shape && v.option2 === quantity);
    if (!found) return;
    current = found;
    quantitySelect.value = [...quantitySelect.options].some(option => option.value === quantity) ? quantity : '';
    $('[data-variant-id]').value = current.id;
    root.dataset.shape = /^(round|redondo|rond|rund)$/i.test(shape) ? 'round' : 'square';
    $('[data-total]').textContent = money(current.price);
    $('[data-unit]').textContent = unit(current.price / Number(quantity));
    $('[data-buy-submit]').disabled = !current.available || busy;
    $('[data-buy-label]').textContent = current.available ? strings.add_quantity.replace('__QTY__',Number(quantity).toLocaleString(config.locale)) : strings.unavailable;
    $('[data-sticky-price]').textContent = money(current.price);
    $('[data-sticky-selection]').textContent = `${shape} · ${Number(quantity).toLocaleString(config.locale)} ${strings.units}`;
    $('[data-sticky-unit]').textContent = `${unit(current.price / Number(quantity))} ${strings.per}`;
    $('[data-sticky-add]').disabled = !current.available || busy;
    const first = config.variants.find(v => v.option1 === shape && v.option2 === '100');
    const saving = first ? Math.floor((1 - (current.price / Number(quantity)) / (first.price / 100)) * 100) : 0;
    $('[data-saving]').hidden = saving <= 0;
    $('[data-saving]').textContent = strings.savings.replace('__PERCENT__', String(saving));
    $$('[data-quick-pack]').forEach(button => {
      const v = config.variants.find(v => v.option1 === shape && v.option2 === button.dataset.quickPack);
      button.setAttribute('aria-pressed',String(button.dataset.quickPack === quantity));
      button.disabled = !v?.available;
      if (v) {
        button.querySelector('[data-quick-total]').textContent = money(v.price);
        button.querySelector('[data-quick-unit]').textContent = unit(v.price / Number(v.option2)) + ' ' + strings.per;
        const packSaving = first?.price > 0 ? Math.max(0, Math.floor((1 - (v.price / Number(v.option2)) / (first.price / 100)) * 100)) : 0;
        const badge = button.querySelector('[data-quick-saving]');
        if (badge) { badge.textContent = strings.pack_saving.replace('__PERCENT__', String(packSaving)); badge.hidden = packSaving <= 0; }
      }
    });
    $$('[data-pack]').forEach((button,index) => {
      const v = config.variants.find(v => v.option1 === shape && v.option2 === button.dataset.pack);
      button.setAttribute('aria-pressed', String(button.dataset.pack === quantity));
      button.disabled = !v?.available;
      if (v) {
        button.querySelector('[data-row-price]').textContent = money(v.price);
        button.querySelector('[data-row-each]').textContent = unit(v.price / Number(v.option2)) + ' / ' + (button.closest('[data-price-list]')?.dataset.unit || strings.units);
      }
      if (!button.closest('[data-price-list]')) button.toggleAttribute('data-extra-row', index >= 10);
      const quantityLabel = button.querySelector('[data-row-quantity]');
      if (quantityLabel) quantityLabel.textContent = Number(button.dataset.pack).toLocaleString(config.locale);
    });
    if (push) {
      const url = new URL(location.href); url.searchParams.set('variant', current.id);
      history.replaceState({}, '', url);
      root.dispatchEvent(new CustomEvent('hc:variant-change', {detail:current, bubbles:true}));
    }
  }
  $$('[data-buy-shape]').forEach(input => input.addEventListener('change', () => {update();showGallery('design');}));
  $$('[data-quick-pack]').forEach(button => button.addEventListener('click',()=>{selectedQuantity=button.dataset.quickPack;update();}));
  quantitySelect.addEventListener('change', () => {if(quantitySelect.value){selectedQuantity=quantitySelect.value;update();}});
  $$('[data-pack]').forEach(button => button.addEventListener('click', () => {
    selectedQuantity = button.dataset.pack; update();
    if (button.closest('[data-price-list]')) {
      $('[data-buy-submit]').scrollIntoView({behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth', block:'center'});
      $('[data-buy-submit]').focus({preventScroll:true});
    }
  }));
  $$('[data-quantities-more]').forEach(button => button.addEventListener('click', () => {
    const open = button.closest('[data-price-list], .hc-price-list').classList.toggle('is-expanded');
    button.setAttribute('aria-expanded', String(open));
    button.textContent = open ? (button.dataset.less || strings.less) : (button.dataset.more || strings.more);
  }));
  function showGallery(key) {
    $$('[data-gallery]').forEach(b => b.setAttribute('aria-pressed',String(b.dataset.gallery===key)));
    $$('[data-gallery-panel]').forEach(p => p.hidden=p.dataset.galleryPanel!==key);
    $('[data-gallery-caption]').textContent=['design','shapes'].includes(key)?strings.caption:strings.shared_caption;
  }
  $$('[data-gallery]').forEach(button=>button.addEventListener('click',()=>showGallery(button.dataset.gallery)));
  $('.hc-gallery-tabs').addEventListener('keydown',event=>{
    if(!['ArrowLeft','ArrowRight','Home','End'].includes(event.key))return;
    event.preventDefault();const buttons=$$('[data-gallery]');let i=buttons.findIndex(b=>b.getAttribute('aria-pressed')==='true');
    i=event.key==='Home'?0:event.key==='End'?buttons.length-1:(i+(event.key==='ArrowRight'?1:-1)+buttons.length)%buttons.length;
    buttons[i].focus();showGallery(buttons[i].dataset.gallery);
  });
  let touchStart=0;
  $('.hc-gallery').addEventListener('touchstart',e=>touchStart=e.changedTouches[0].screenX,{passive:true});
  $('.hc-gallery').addEventListener('touchend',e=>{
    const dx=e.changedTouches[0].screenX-touchStart;if(Math.abs(dx)<60)return;
    const buttons=$$('[data-gallery]');const i=buttons.findIndex(b=>b.getAttribute('aria-pressed')==='true');showGallery(buttons[(i+(dx<0?1:-1)+buttons.length)%buttons.length].dataset.gallery);
  },{passive:true});
  $$('[data-zoom-open]').forEach(button=>button.addEventListener('click',()=>{
    const original=button.querySelector('img');if(!original)return;
    const image=original.cloneNode();image.loading='eager';
    const wrap=document.createElement('div');wrap.className=button.querySelector('.hc-art-cut')?'hc-zoom-art '+root.dataset.shape:'hc-zoom-photo';wrap.append(image);
    $('[data-zoom-content]').replaceChildren(wrap);$('[data-zoom-dialog]').showModal();
  }));
  $('[data-zoom-close]').addEventListener('click',()=>$('[data-zoom-dialog]').close());
  $('[data-zoom-dialog]').addEventListener('click',e=>{if(e.target===e.currentTarget)e.currentTarget.close();});
  $$('[data-studio-link]').forEach(link => {
    const url = new URL(link.href);
    const theme = new URL(location.href).searchParams.get('preview_theme_id');
    if (theme) url.searchParams.set('preview_theme_id', theme);
    link.href = url;
  });
  const sticky = $('[data-pdp-sticky]');
  const observer = new IntersectionObserver(entries => { sticky.hidden = entries[0].isIntersecting; }, {threshold:0});
  observer.observe($('[data-buy-submit]'));
  $('[data-sticky-add]').addEventListener('click', () => {
    if (config.studio && !$('[data-hc-approve]')?.checked) {
      $('[data-hc-approve]')?.scrollIntoView({behavior:'smooth', block:'center'});
      $('[data-hc-approve]')?.focus({preventScroll:true});
      return;
    }
    form.requestSubmit();
  });
  form.addEventListener('submit', async event => {
    event.preventDefault();
    if (busy || !current.available) return;
    busy = true; update(false);
    const error = $('[data-buy-error]'); error.hidden = true;
    $('[data-buy-success]').hidden = true;
    $('[data-buy-label]').textContent = strings.adding;
    const data = new FormData(form);
    const ids = [...new Set([...document.querySelectorAll('cart-items-component[data-section-id]')].map(el=>el.dataset.sectionId))];
    if (ids.length) data.set('sections', ids.join(','));
    data.set('sections_url', location.pathname + location.search);
    const deferred = CartLinesUpdateEvent.createPromise();
    form.dispatchEvent(new CartLinesUpdateEvent({action:'add', context:'product', lines:[{merchandiseId:String(current.id),quantity:1}],promise:deferred.promise}));
    try {
      const response = await fetch(base + 'cart/add.js', {method:'POST', headers:{Accept:'application/json'}, body:data});
      const result = await response.json();
      if (!response.ok || result.status) throw new Error(result.description || result.message || strings.error);
      const cartResponse = await fetch(base + 'cart.js', {headers:{Accept:'application/json'}});
      if (!cartResponse.ok) {
        deferred.resolve({detail:{didError:true}});
        location.assign(config.cartUrl);
        return;
      }
      const cart = await cartResponse.json();
      deferred.resolve({cart:CartLinesUpdateEvent.createCartFromAjaxResponse(cart),detail:{source:'product-form-component',sourceId:form.id,productId:config.id,itemCount:1,items:cart.items,sections:result.sections}});
      $('[data-buy-success]').hidden = false;
      deferred.promise.then(openCartDrawer).catch(() => {});
    } catch(e) {
      deferred.resolve({detail:{didError:true}});
      error.textContent = e.message || strings.error; error.hidden = false;
      error.scrollIntoView({behavior:'smooth',block:'center'});
    } finally { busy = false; update(false); }
  });
  update(false);
}
document.querySelectorAll('[data-hc-pdp]').forEach(initPdp);
document.addEventListener('shopify:section:load',event=>event.target.querySelectorAll('[data-hc-pdp]').forEach(initPdp));

new MutationObserver(records => {for(const record of records) for(const node of record.addedNodes) if(node.nodeType===1) {if(node.matches('[data-hc-pdp]')) initPdp(node);node.querySelectorAll('[data-hc-pdp]').forEach(initPdp);}}).observe(document.body,{childList:true,subtree:true});

